import { useEffect, useRef } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { TextField, Dropdown, Button, Typography, InlineAlert } from '@nwh-consumer-digital/nw-component-lib'
import { Grid, Box, Paper } from '@mui/material'
import styled from '@emotion/styled'
import { useProgress } from '../context/ProgressContext'

const Item = styled(Paper)(() => ({
  textAlign: 'left',
  maxWidth: '400px',
  marginBottom: '18px', // There is an extra 6 pixels this makes 24px
}))

const minorPageOne = (props) => {
  const { SubmissionState, onFormStateChange } = props
  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({ mode: 'onBlur' })
  //UseProgress Context Hook
  const { updateProgress } = useProgress()

  useEffect(() => {
    // Set Value For Progress
    updateProgress(30)

    if (SubmissionState.sectionOneForm) {
      setValue('firstName', SubmissionState.sectionOneForm?.firstName)
      setValue('lastName', SubmissionState.sectionOneForm?.lastName)
      setValue('mInitial', SubmissionState.sectionOneForm?.mInitial)
      setValue('DOBChild', SubmissionState.sectionOneForm?.DOBChild)
      setValue('gender', SubmissionState.sectionOneForm?.gender)
      setValue('streetNumber', SubmissionState.sectionOneForm?.streetNumber)
      setValue('City', SubmissionState.sectionOneForm?.City)
      setValue('State', SubmissionState.sectionOneForm?.State)
      setValue('Zip', SubmissionState.sectionOneForm?.Zip)
      setValue('relationshiptoPatient', SubmissionState.sectionOneForm?.relationshiptoPatient)
    }
  }, [])

  // Count the number of errors on the page and, if any are found, scroll to the reference above the inline alert box after tallying them.
  const errorCount = Object.keys(errors).length
  const targetRef = useRef(null)
  const scrollToTarget = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }
  useEffect(() => {
    if (errorCount > 0) {
      scrollToTarget()
    }
  }, [errors])

  const handleRegistration = (data) => {
    SubmissionState.sectionOneForm = data
    SubmissionState.goBackPageTwo = true
    onFormStateChange()
  }

  return (
    <Box>
      <Grid container direction="column" justifyContent="space-between" alignItems="left">
        <Grid item xs={12}>
          <Typography
            variant="h1"
            sx={{
              marginTop: { xs: '1.25rem', sm: '1.25rem', md: '1.25rem', lg: '5rem', xl: '5rem' },
              marginBottom: { xs: '2rem', sm: '2rem', md: '2rem', lg: '2rem', xl: '2rem' },
            }}>
            未成年人 信息
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            maxWidth: window.innerWidth <= 768 ? '400px' : 'none',
            marginBottom: 24,
            textAlign: 'justify',
            lineHeight: 1.6,
            wordSpacing: '0.05em',
          }}>
          <Typography type="body" size="large" weight="light">
            {' '}
            如果您是 Northwell Health 13 岁以下患者的父母或法定监护人，您可以填写此表申请“代理人访问权限”(proxy
            access)，以获取您子女在 Northwell 患者门户网站（MyNorthwell、FollowMyHealth）上的健康信息。拥有代理
            人访问权限，即表示您可以查看子女的部分健康信息，在某些情况下，还可以通过门户网站与子女的医疗保健
            团队进行交流。在您的子女年满 13 岁后，您将无法再查看 Northwell 患者门户网站中的任何新信息。
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            maxWidth: window.innerWidth <= 768 ? '400px' : 'none',
            marginBottom: 24,
            textAlign: 'justify',
            lineHeight: 1.6,
            wordSpacing: '0.05em',
          }}>
          <Typography type="body" size="large" weight="light">
            {' '}
            代理人访问权限不会影响您通过其他方式申请访问您子女医疗记录的权利。请注意，账单信息不会自动向代理人
            提供。只有患者和负责支付患者医疗费用的个人（担保人）有权查看账单信息。也可向 Northwell 健康信息管理 部
            (Health Information Management Department) 提交索取医疗记录副本的书面申请。如有任何疑问或疑虑，请
            联系服务提供者的前台工作人员。
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            maxWidth: window.innerWidth <= 768 ? '400px' : 'none',
            marginBottom: 24,
            textAlign: 'justify',
            lineHeight: 1.6,
            wordSpacing: '0.05em',
          }}>
          <Typography type="body" size="large" weight="light">
            {' '}
            Enter the minor's information details below whom you are requesting proxy access for.
          </Typography>
        </Grid>
        <form onSubmit={handleSubmit(handleRegistration)}>
          <Grid item xs={12} className="requiredSpacing">
            <Item elevation={0}>
              <label ref={targetRef} className="required">
                <span className="red">*</span> 必需的
              </label>
            </Item>
          </Grid>
          {errorCount > 0 && (
            <Grid item xs={12}>
              <Item elevation={0}>
                <InlineAlert severity="error" fullWidth text={`There are ${errorCount} errors on this page.`} />
              </Item>
            </Grid>
          )}
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="firstName"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="firstName"
                    onChange={onChange}
                    defaultValue={SubmissionState.sectionOneForm?.firstName}
                    label={
                      <span>
                        患者名字 <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.firstName)}
                    helperText={
                      errors?.firstName
                        ? errors?.firstName?.type === 'required'
                          ? 'First name is required.'
                          : errors?.firstName?.type === 'pattern'
                          ? 'First name contains invalid characters.'
                          : 'First name is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="lastName"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="lastName"
                    defaultValue={SubmissionState.sectionOneForm?.lastName}
                    onChange={onChange}
                    label={
                      <span>
                        患者姓氏 <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.lastName)}
                    helperText={
                      errors?.lastName
                        ? errors?.lastName?.type === 'required'
                          ? 'Last name is required.'
                          : errors?.lastName?.type === 'pattern'
                          ? 'Last name contains invalid characters.'
                          : 'Last name is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="mInitial"
                control={control}
                rules={{ pattern: { value: /^[A-Za-z]+$/, message: 'Please use alphabetic characters only' } }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    id="mInitial"
                    onChange={onChange}
                    value={SubmissionState.sectionOneForm?.mInitial}
                    label="中间名缩写"
                    fullWidth
                    error={Boolean(errors?.mInitial)}
                    helperText={errors?.mInitial?.message || ''}
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="DOBChild"
                control={control}
                rules={{
                  pattern:
                    /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/(19\d{2}|20[0-2]\d|20[2-9][0-9]|20[3-9][0-9]|21\d{2})$/,
                  required: true,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="DOBChild"
                    defaultValue={SubmissionState.sectionOneForm?.DOBChild}
                    onChange={onChange}
                    label={
                      <span>
                        患者出生日期 (月/日/年) <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.DOBChild)}
                    helperText={
                      errors?.DOBChild
                        ? errors?.DOBChild?.type === 'required'
                          ? 'Date of Birth is required.'
                          : errors?.DOBChild?.type === 'pattern'
                          ? 'Please use numeric characters only, and correct Month/Date/Year values.'
                          : 'Date of Birth is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="gender"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <Dropdown
                    id="gender"
                    label={
                      <span>
                        Birth gender <span className="red">*</span>
                      </span>
                    }
                    value={value}
                    onChange={onChange}
                    error={Boolean(errors?.gender)}
                    helperText={errors?.gender ? 'Birth gender is required' : undefined}
                    selectOptions={[
                      { name: 'Female', value: 'Female' },
                      { name: 'Male', value: 'Male' },
                      { name: 'Other', value: 'Other' },
                    ]}
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="streetNumber"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Za-z0-9 -]+$/,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="streetNumber"
                    defaultValue={SubmissionState.sectionOneForm?.streetNumber}
                    onChange={onChange}
                    label={
                      <span>
                        街道地址 <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.streetNumber)}
                    helperText={
                      errors?.streetNumber
                        ? errors?.streetNumber?.type === 'required'
                          ? 'Address is required.'
                          : errors?.streetNumber?.type === 'pattern'
                          ? 'Please use alphabetic characters only'
                          : 'Address is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="City"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="City"
                    defaultValue={SubmissionState.sectionOneForm?.City}
                    onChange={onChange}
                    label={
                      <span>
                        城市 <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.City)}
                    helperText={
                      errors?.City
                        ? errors?.City?.type === 'required'
                          ? 'City is required.'
                          : errors?.City?.type === 'pattern'
                          ? 'Please use alphabetic characters only'
                          : 'City is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="State"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="State"
                    defaultValue={SubmissionState.sectionOneForm?.State}
                    onChange={onChange}
                    label={
                      <span>
                        州 <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.State)}
                    helperText={
                      errors?.State
                        ? errors?.State?.type === 'required'
                          ? 'State is required.'
                          : errors?.State?.type === 'pattern'
                          ? 'Please use alphabetic characters only'
                          : 'State is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="Zip"
                control={control}
                rules={{
                  required: true,
                  pattern: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="Zip"
                    onChange={onChange}
                    defaultValue={SubmissionState.sectionOneForm?.Zip}
                    label={
                      <span>
                        邮政编码 <span className="red">*</span>
                      </span>
                    }
                    error={errors?.Zip}
                    fullWidth
                    helperText={
                      errors?.Zip
                        ? errors?.Zip?.type === 'required'
                          ? 'Zipcode is required.'
                          : errors?.Zip?.type === 'pattern'
                          ? 'Please use 5 digits of numeric characters only'
                          : 'Zipcode is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="relationshiptoPatient"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange } }) => (
                  <Dropdown
                    id="relationshiptoPatient"
                    defaultValue={SubmissionState.sectionOneForm?.relationshiptoPatient || []}
                    label={
                      <span>
                        与患者的关系 <span className="red">*</span>
                      </span>
                    }
                    selectOptions={[
                      { name: '父母', value: '父母' },
                      { name: '法定监护人', value: '法定监护人' },
                    ]}
                    onChange={onChange}
                    error={Boolean(errors?.relationshiptoPatient)}
                    helperText={errors?.relationshiptoPatient ? 'Relationship to patient is required' : undefined}
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid>
            <Item elevation={0}>
              <Button text="Continue" color="primary" type="submit" />
            </Item>
          </Grid>
        </form>
      </Grid>
    </Box>
  )
}
export default minorPageOne
